import ukSettingsReducer from "./ukSettingsSlice";

export default ukSettingsReducer;
